/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Gpmaximumticketsize4Inputs */

const en_coinvestments_tracking_gpmaximumticketsize4 = /** @type {(inputs: Coinvestments_Tracking_Gpmaximumticketsize4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est. Max. Ticket Size`)
};

/**
* | output |
* | --- |
* | "Est. Max. Ticket Size" |
*
* @param {Coinvestments_Tracking_Gpmaximumticketsize4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_gpmaximumticketsize4 = /** @type {((inputs?: Coinvestments_Tracking_Gpmaximumticketsize4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Gpmaximumticketsize4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_gpmaximumticketsize4(inputs)
});
export { coinvestments_tracking_gpmaximumticketsize4 as "coInvestments_tracking_gpMaximumTicketSize" }